import { $t } from '@/i18n';
import { computed, reactive, watch, ref, getCurrentInstance } from '@vue/composition-api';
import { fetchRtxInfo, ONE_DAY_MS, usePermissionSettings } from './utils';
import { providePermState } from '@pages/modules/permission/PermState';
export function useExpire(users, { readonly = ref(false), options = ref([]), checkPangu = true, permissionSetting = ref(), onlyTag = false, } = {}) {
    let permissionSettings;
    if (permissionSetting.value) {
        // @ts-ignore
        permissionSettings = permissionSetting;
    }
    else {
        permissionSettings = usePermissionSettings().permissionSettings;
    }
    const { panguMappingEnabled, initAuthSetting } = providePermState();
    if (checkPangu) {
        const { props } = getCurrentInstance();
        initAuthSetting(props.projectId, props.env || 'dev');
    }
    const permissionOptions = computed(() => {
        // 用传进来的
        if (options.value.length > 0) {
            return options.value;
        }
        if (permissionSettings.value.expireOptions?.length) {
            return permissionSettings.value.expireOptions;
        }
        return [
            { label: $t('k_18dc91ec'), value: 1 },
            { label: $t('k_6f43158'), value: 3 },
            { label: $t('k_fdc2ba01'), value: 30 },
            { label: $t('k_232af8cb'), value: 90 },
            { label: $t('k_e399f4b2'), value: 365 },
        ];
    });
    const expireOptions = reactive({
        expire: 0,
        expireAt: 0,
        rtxList: [],
    });
    // 先简单过滤一下 后面从配置里捞
    const selectOptions = computed(() => {
        let maxDay = permissionSettings.value.maxDays;
        if (parseInt(`${maxDay}`, 10) === 0) {
            maxDay = 0;
        }
        const result = [
            ...permissionOptions.value,
            !maxDay && { label: $t('k_9c60fc86'), value: 0 },
        ].filter(Boolean)
            .filter(config => config.value <= (maxDay || 365));
        return result;
    });
    watch(() => selectOptions.value, (val) => {
        if (!expireOptions.expire && !readonly.value) {
            expireOptions.expire = val[val.length - 1].value;
        }
    }, { immediate: true });
    watch(() => expireOptions.expire, (val) => {
        expireOptions.expireAt = val ? Date.now() + val * ONE_DAY_MS : val;
    }, { immediate: true });
    const expireRules = computed(() => permissionSettings.value?.expireRules || []);
    watch(() => users.value, async (val) => {
        if (!val.filter(Boolean).length)
            return;
        // 捞一下rtx身份匹配特殊规则
        const res = await fetchRtxInfo(val.filter((r) => typeof r === 'string'));
        expireOptions.rtxList = res;
    }, { immediate: true });
    const warningList = computed(() => expireOptions.rtxList
        .filter(item => expireRules.value.find(rule => rule.typeName.includes(item.typeName)))
        .map(item => ({
        warnText: $t(`k_edacc123`, { arg_0: item.id + (item.chnName ? `(${item.chnName})` : ''), arg_1: item.typeName, arg_2: expireRules.value.find(i => i.typeName.includes(item.typeName))?.maxDays }),
        info: item,
    })));
    const renderTypeWarning = function () {
        return warningList.value.map(item => (<a-alert showIcon={false} message={item.warnText} banner/>));
    };
    const renderCreateExpire = function () {
        // 开了盘古就不启用权限过期了
        if (panguMappingEnabled.value)
            return [];
        if (readonly.value) {
            return <a-form-model-item label={$t('k_8994648d')} style="user-select: none;">
        {selectOptions.value.find(option => option.value === expireOptions.expire)?.label
                    || ($t('k_b466d9e7', { arg_0: expireOptions.expire }))}
      </a-form-model-item>;
        }
        const tags = selectOptions.value.map(({ label, value }) => {
            const change = (v) => v && (expireOptions.expire = value);
            const val = expireOptions.expire === value;
            return <a-checkable-tag checked={val} onChange={change}>
        {label}
      </a-checkable-tag>;
        });
        if (onlyTag) {
            return tags;
        }
        return [<a-form-model-item label={$t('k_8994648d')} required style="user-select: none;">
      {tags}
      {renderTypeWarning()}
    </a-form-model-item>,
        ];
    };
    return {
        selectOptions,
        expireOptions,
        renderCreateExpire,
    };
}
